<template>
  <van-overlay :show="show" show-cancel-button @click="show = false" @confirm="confirm" :lock-scroll="false">
    <div class="wrapper" @click.stop>
      <div class="wrapper-content">
        <div class="wrapper-title"> 欢迎回来！ </div>
        <div class="wrapper-subtitle">
          送您{{ couponName }}课程兑换券，已为您兑换，快去看看吧！
        </div>
        <img :src="getImageUrl(itemImage)" width="100%" />
      <div class="wrapper-footer">
        <van-button @click="confirm">我知道了</van-button>
      </div>

      </div>

    </div>
  </van-overlay>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  components: {},
  props: {

  },
  data () {
    return {
      show: false,
      res: {},
      couponName: '',
      itemImage: ''
    }
  },
  computed: {},
  methods: {
    open (res) {
      this.res = res
      if (res) {
        this.couponName = res.data.resultData.activityCoinDTO.couponName || ''
        this.itemImage = res.data.resultData.activityCoinDTO.itemImage || ''
      }
      this.show = true
    },
    confirm () {
      this.show = false
      this.$emit('after-confirm', this.res)
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>
<style lang='less' scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .wrapper-content {
    position: relative;
    width: 80vw;
    background-color: #fff;
    text-align: center;
    box-sizing: border-box;
    border-radius: 10px;
    border: none;
    padding: 20px 30px 10px 30px;

    .wrapper-body {
      padding: 10px;
      padding-bottom: 0px;
      max-height: 50vh;
      overflow-x: hidden;
      overflow-y: auto;

    }

    .wrapper-title {
      font-size: 18px;
      line-height: 25px;
      font-weight: 700;
    }

    .wrapper-subtitle {
      font-size: 14px;
      line-height: 16px;
      color: #909090;
      margin: 10px 0px;
    }

    .wrapper-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .van-button {
        width: 100%;
        border: none;
        font-size: 16px;
      }
    }
  }

  .get-card-bg {
    width: 50%;
    position: absolute;
    top: -60px;
    left: 25%;
    z-index: 9999;
  }
}

.subtitle {
  text-align: center;
  color: #909090;
  font-size: 14px;
}
</style>
